import { gql } from '@apollo/client';

export default gql`
  query profileBookings($customerId: String!, $lastName: String!, $bookingSearchType: BookingSearchType!, $page: Int!, $size: Int!) {
    profileBookings(customerId: $customerId, lastName: $lastName, bookingSearchType: $bookingSearchType, page: $page, size: $size) {
      items {
        origin
        destination
        outboundDateTime
        returnDateTime
        outboundDirect
        inboundDirect
        outboundServiceClass
        outboundServiceClassName
        returnServiceClass
        returnServiceClassName
        reference
        isEligibleForUpgradeWithPoints
        tickets {
          serviceClass
          serviceClassName
          departureDate
          departureTime
          origin
          originCode
          destination
          destinationCode
          numberOfPassengers
          isCancelled
        }
      }
      pagination {
        totalItems
        currentPage
        totalPages
      }
    }
  }
`;
